import React from 'react'
import { ModalWrapper } from '../../../../../../components'
import { useSelector } from 'react-redux'
import { InfoField } from '../../School/PopOver/SchoolInfo'
import { formatDate } from '../../../../../../components/Table/TableCells/TableCell'
import { Avatar, Typography } from '@mui/material'
import { QRicon } from '../../../../../../assets/icons'
import { QRCodeDisplay } from '../../School/SchoolRegistration/components/Steps'

export const HolidayDetail = ({ open, handleClose }) => {
  const data = useSelector((state) => state.global.SchoolDInfo)
  const [downloadQR, setDownload] = React.useState(false)

  return (
    <ModalWrapper
      open={open}
      handleClose={handleClose}
      title={'Student Information'}
      width={'fit-content'}
    >
      <div className="add-employee">
        <div className="emp-det-head" style={{ marginBottom: '15px' }}>
          <div>
            <Typography className="field-label">Avatar</Typography>
            {data?.student_avatar ? (
              <img src={data?.student_avatar} alt="" className="employee-img" />
            ) : (
              <Avatar
                alt={''}
                sx={{
                  width: '76px',
                  height: '76px',
                  mt: 1,
                  fontSize: '30px',
                  backgroundColor: '#F2ECF9',
                  color: '#492972',
                }}
              >
                {data?.student_name?.charAt(0)?.toUpperCase()}
              </Avatar>
            )}
          </div>
          <div className="download-qr-block" onClick={() => setDownload(true)}>
            <img src={QRicon} alt="" />
            <Typography className="download-qr">Show QR Code</Typography>
          </div>
          {downloadQR && (
            <QRCodeDisplay
              name={data?.student_name}
              open={downloadQR}
              handleClose={() => setDownload(false)}
              value={data?.student_id}
            />
          )}
        </div>
        <div className="text-fields">
          <InfoField value={data?.student_name} label={'Student Name'} />
          <InfoField
            label={'Registration Number'}
            name={'registrationNo'}
            value={data?.student_registration_number}
            required
          />
        </div>
        <div className="text-fields">
          <InfoField label={'Date of Birth'} value={formatDate(data?.student_dob)} />
          <InfoField label={'Aadhar Number'} value={data?.student_aadhar_number} />
        </div>
        <div className="text-fields">
          <InfoField label={'Father’s Name'} value={data?.student_father_name} />
          <InfoField label={'Mother’s Name'} value={data?.student_mother_name} />
        </div>
        <div className="text-fields">
          <InfoField label={'Father’s Contact Number'} value={data?.student_father_contact} />
          <InfoField
            label={'Alternate Contact Number'}
            value={data?.student_alternate_contact_number}
          />
        </div>

        <div className="text-fields">
          <InfoField label={'Address'} value={data?.student_address || '-'} />
          <InfoField label={'Address 2'} value={data?.student_address_two || '-'} />
        </div>
        <div className="text-fields">
          <InfoField label={'City'} value={data?.student_city || '-'} />
          <InfoField label={'Caste'} value={data?.student_caste} />
        </div>
        <div className="text-fields">
          <InfoField label={'Fee'} value={data?.student_fee} />
          <InfoField label={'Discount Fee'} value={data?.student_discount} />
        </div>
        <div className="text-fields">
          <InfoField label={'Transport Fee'} value={data?.student_transport_fee} />
          <InfoField label={'Misc Fee'} value={data.student_misc_fee} />
        </div>
        <InfoField label={'Last Year Due Fee'} value={data?.student_fee_last_year_due} />
      </div>
    </ModalWrapper>
  )
}
